<template>
  <div>
    <v-app-bar class="portalHeader" dense>
      <v-btn icon @click="openDrawer">
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </v-btn>
      <div class="sites_name_wrapper">
        <v-btn @click="openSearchDialog">
          <div class="sites_name">
            {{ currentSite ? currentSite.name : "-" }}
          </div>
          <v-spacer></v-spacer>
          <v-icon> mdi-menu-down </v-icon>
        </v-btn>
      </div>
      <div class="portalHeader-title">
        <img
          class="portalHeader-logo"
          src="@/assets/rakuraku.png"
          @click="onClickLogo"
        />
        <div class="portalHeader-label">（マスター登録）</div>
      </div>
      <v-tabs right v-model="active_tab">
        <v-tab
          v-for="val in HEADER_MENU_ITEMS_INHOUSE_ARRAY"
          :key="val.id"
          @change="(menu = val), onChange(val.id)"
          >{{ val.name }}</v-tab
        >
      </v-tabs>
    </v-app-bar>
    <Popup width="500px" :dialog="isShowSearchDialog">
      <FieldsSelectDialog
        title="現場管理画面"
        :formValues="formValues"
        @formUpdate="formUpdate"
        @onSearch="searchSite"
        @close="isShowSearchDialog = false"
      />
    </Popup>
  </div>
</template>

<script>
import { Store } from "@/store/Store.js";
import {
  HEADER_MENU_ITEMS_INHOUSE_ARRAY,
  HEADER_MENU_ITEMS_INHOUSE,
  HEADER_MENU_ITEMS_FIELD,
} from "@/constants/GLOBALHEADER";

// Components
import FieldsSelectDialog from "./components/FieldsSelectDialog";
import Popup from "@/components/common/Popup.vue";

export default {
  components: {
    FieldsSelectDialog,
    Popup,
  },
  data() {
    return {
      HEADER_MENU_ITEMS_INHOUSE_ARRAY,
      active_tab: 0,
      formValues: {
        items: [],
        keyword: "",
        main_contractor_id: null,
        end_use_flg: null,
        selected: null,
      },
      isShowSearchDialog: false,
    };
  },
  async mounted() {
    this.$watch(
      () => Store.getters[`GlobalHeader/getInHouseMenuId`],
      (menuId) => {
        this.active_tab = menuId;
      },
      {
        immediate: true,
      }
    );
    this.$watch(
      () => Store.getters[`GlobalHeader/getSiteList`],
      (data) => {
        const siteList = [...data];
        this.formValues.items = siteList;
      },
      {
        immidiate: true,
        deep: true,
      }
    );
  },
  computed: {
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    currentSite() {
      return Store.state.GlobalHeader.selectedSite;
    },
  },
  methods: {
    onChange(menuId) {
      const selectedMenu = HEADER_MENU_ITEMS_INHOUSE_ARRAY.find((item) => {
        return item.id === menuId;
      });
      Store.dispatch("GlobalHeader/setInHouseMenu", { menuId: menuId });
      this.$router.push(selectedMenu.path).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    openDrawer() {
      Store.dispatch("Drawer/show");
    },
    async openSearchDialog() {
      const result = await Store.dispatch("GlobalHeader/searchSites", {
        keyword: "",
        main_contractor_id:
          this.loginUser.role == 9 ? this.loginUser.main_contractor_id : null,
      });
      if (result.hasError) {
        Store.dispatch("Error/show", {
          status: 200,
          message: "現場情報が取得できませんでした。",
        });
        return;
      }
      this.isShowSearchDialog = true;
    },
    async searchSite() {
      const { keyword, main_contractor_id, end_use_flg } = this.formValues;
      const result = await Store.dispatch("GlobalHeader/searchSites", {
        keyword,
        end_use_flg,
        main_contractor_id,
      });
      if (result.hasError) {
        Store.dispatch("Error/show", {
          status: 200,
          message: result.data.message,
        });
      }
    },
    formUpdate(values) {
      this.formValues = { ...values };
      if (this.formValues.selected) {
        Store.dispatch("GlobalHeader/setSite", {
          field_id: this.formValues.selected,
        });
        this.isShowSearchDialog = false;
        const formValues = {
          items: [],
          keyword: "",
          selected: null,
        };
        this.formValues = formValues;
        this.$router
          .push(HEADER_MENU_ITEMS_FIELD.INSPECTOR_FIELD.path)
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
    },
    onClickLogo() {
      this.$router
        .push(HEADER_MENU_ITEMS_INHOUSE.MACHINES.path)
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/themes.scss";

.v-sheet {
  background-color: $primary_color !important;
}
.v-tab {
  color: $primary_color !important;
}
.v-tab:not(.v-tab--active) {
  color: $secondary_color !important;
}
.v-tabs ::v-deep .v-tab--active {
  background-color: $accent_color !important;
  border-radius: 0 !important;
  border: 0 solid $secondary_color;
  border-bottom: 2px solid $secondary_color;
}
::v-deep .v-tabs-bar__content {
  background-color: $primary_color;
}
</style>
